const FIELDS = [
  { id: 'ip_name', label: 'Наименование ИП', icon: 'ri-briefcase-line', placeholder: 'ИП Иванов Иван Иванович' },
  { id: 'inn', label: 'ИНН', icon: 'ri-id-card-line', placeholder: '123456789012 (12 цифр)' },
  { id: 'ogrnip', label: 'ОГРНИП', icon: 'ri-file-list-2-line', placeholder: '123456789012345 (15 цифр)' },
  { id: 'bank', label: 'Наименование банка', icon: 'ri-bank-line', placeholder: 'ПАО Сбербанк' },
  { id: 'bik', label: 'БИК банка', icon: 'ri-building-line', placeholder: '044525225 (9 цифр)' },
  { id: 'account', label: 'Расчётный счёт', icon: 'ri-currency-line', placeholder: '40802810938000012345 (20 цифр)' },
  { id: 'corr_account', label: 'Корр. счёт', icon: 'ri-exchange-funds-line', placeholder: '30101810400000000225 (20 цифр)' },
];

import { useNavigate } from 'react-router-dom';
import { useCabinet } from '../useCabinet';

export default function MyRequisites() {
  const navigate = useNavigate();
  const { config } = useCabinet();
  return (
    <div className="max-w-2xl">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-1">Мои реквизиты</h2>
        <p className="text-foreground-500 text-sm">Реквизиты для начисления выплат</p>
      </div>

      {/* Alfa-Bank meeting CTA */}
      {config.features.meetingRequest && (
        <div className="bg-gradient-to-br from-red-500/10 to-transparent border border-red-500/25 rounded-2xl px-5 py-5 mb-6">
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 rounded-xl flex items-center justify-center bg-red-500/15 border border-red-500/25 flex-shrink-0">
              <i className="ri-bank-line text-xl text-red-400" />
            </span>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-white">
                Назначить встречу с представителем Альфа-Банка
              </p>
              <p className="text-xs text-foreground-500 mt-0.5">
                Оформление расчетного счета — выберите место, дату и время
              </p>
            </div>
          </div>
          <button
            onClick={() => navigate('/meeting')}
            className="mt-4 w-full flex items-center justify-center gap-2 bg-red-500 hover:bg-red-400 text-white font-semibold rounded-xl py-3 text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line" />
            Назначить встречу
          </button>
        </div>
      )}

      {/* Locked banner */}
      <div className="flex items-start gap-3 bg-accent-300/8 border border-accent-300/20 rounded-2xl px-5 py-4 mb-6">
        <span className="w-5 h-5 flex items-center justify-center text-accent-200 flex-shrink-0 mt-0.5">
          <i className="ri-lock-fill text-base" />
        </span>
        <div>
          <p className="text-sm font-semibold text-accent-200 mb-1">Раздел заблокирован</p>
          <p className="text-sm text-accent-200/70 leading-relaxed">
            Заполнение реквизитов станет доступно после завершения процесса оформления.
            Обратитесь к вашему менеджеру для получения дальнейших инструкций
          </p>
        </div>
      </div>

      {/* Fields */}
      <div className="space-y-4">
        {FIELDS.map((field) => (
          <div key={field.id} className="relative">
            <label className="block text-xs font-medium text-foreground-400 mb-2">
              {field.label}
            </label>
            <div className="relative">
              <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-300">
                <i className={`${field.icon} text-base`} />
              </span>
              <input
                type="text"
                disabled
                placeholder={field.placeholder}
                className="w-full bg-[#141417]/40 border border-dashed border-[#26262c] rounded-xl pl-11 pr-12 py-3.5 text-sm text-foreground-300 placeholder-foreground-200 cursor-not-allowed"
              />
              <span className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-accent-400">
                <i className="ri-lock-2-line text-sm" />
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <button
          disabled
          className="w-full flex items-center justify-center gap-2 bg-[#141417]/50 border border-dashed border-[#26262c] text-foreground-300 rounded-xl py-3.5 text-sm cursor-not-allowed whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-lock-2-line" />
          </span>
          Сохранить реквизиты (недоступно)
        </button>
      </div>
    </div>
  );
}
